import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { showToast,ToastMessage } from '../../Shared/ToastMessage';
import { baseUrl } from '../../../api/common';
const CountryAdd = ({fetchCountryData,addPopupStatus, handleAddPopup, eventType, updateData}) => {

  const [updateId, setUpdateId] = useState("");

  const [formValues, setFormValues] = useState({
    country_name: ''
  });

  const [errors, setErrors] = useState({
    countryName: ''
  });

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setFormValues({ ...formValues, flag: file }); 
  };

  const validate = () => {
    const newErrors = {
      countryName: ''
    };  
    if (!formValues.country_name.trim()) {
      newErrors.countryName = 'Country name cannot be empty';
    }  
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };  

  const clearInputValues = () => {
    setErrors({
      countryName: ''
    });
    setFormValues({
      country_name: ''
    });
    handleAddPopup(false);
  };  

  const addUpdateCountry = async () => {
    if (validate()) {
      console.log('Post Data:', formValues);   
      try {
        const requestData = {
          ...formValues,
          ...(eventType === "Update" && { id: updateId }),
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(
          `${baseUrl}/api/add_country`,
          requestData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );
        if (response.data.status) {
          showToast(response.data.message, 'success');
          fetchCountryData();
          clearInputValues();
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("Submission failed. Please try again.", "error");
      }
    }
  };

  useEffect(() => {
    if (eventType === "Update" && updateData) {
      console.log("Update Data:", updateData);
      setUpdateId(updateData.id);
      setFormValues({
        country_name: updateData.country_name || ''
      });
    }else{
      setErrors({
        countryName: ''
      });
      setFormValues({
        country_name: ''   
      });    
    }
  }, [eventType, updateData, addPopupStatus]);

  return (
    <>
    <ToastMessage/>    
    {addPopupStatus && (
      <div
        className={`extraspace_search_div search_div${addPopupStatus ? ' open' : ''}`}
      >
        <div className="card member_master_sidebar_scrool">
          <div className="member_edit_pop_flex mb-3 text-end">
            <h3>{eventType} Country</h3>
            <div className="input-group-append">
              <span
                onClick={() => clearInputValues()}
                className="search_toggle btn btn-danger"
              >
                <i className="fa fa-times" />
              </span>
            </div>
          </div>
          <div className="table-responsive">
            <div className="body application_body_side">
              <div>             
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>Country Name</label>
                        <input
                          type="text"
                          className={`form-control ${errors.countryName?"red_border":''}`}
                          value={formValues.country_name}
                          onChange={(e) => handleInputChange('country_name', e.target.value)} 
                          required
                        />
                        {errors && (                          
                            <p className="text-danger pos_abos">{errors.countryName}</p>                          
                        )}
                      </div>

                    </div>
                    <div className="col-md-12 member_button_flex">
                      <button onClick={() => addUpdateCountry()} className="btn btn-outline-info">
                      {eventType}
                      </button>
                      <a
                        onClick={() => clearInputValues()}
                        className="btn btn-outline-danger"
                      >
                        Close
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default CountryAdd;
